import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AccountService } from '../../services';
interface IUsernameChangeModalContext {
  data: string;
  title?: string;
  isUsername?: boolean;
}
@Component({
  selector: 'app-username-change-modal',
  templateUrl: './user-new-modal.component.html',
  styleUrls: ['./user-new-modal.component.scss'],
})
export class UsernameChangeModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  screen: string;
  userForm: FormGroup;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IUsernameChangeModalContext, void, void>,
    private accountSvc: AccountService
  ) {
    this.userForm = fb.group({
      password: ['', Validators.required],
      usernameOrEmail: ['', Validators.required],
      // appUserEmail: [ '' ]
    });
  }
  isFieldValid(field: string) {
    return (
      (!this.userForm.get(field).valid && this.userForm.get(field).touched) ||
      (this.userForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  continue() {
    this.error = null;
    if (this.userForm.value.password !== '') {
      this.screen = 'value';
    } else {
      this.error = 'Password is required to continue';
    }
  }
  submit() {
    this.formSubmitAttempt = false;
    if (this.userForm.valid) {
      this.pending = true;
      this.modal.context.isUsername == true
        ? this.saveUsername()
        : this.saveEmail();
    } else {
      this.formSubmitAttempt = true;
    }
  }
  saveEmail() {
    this.accountSvc
      .changePrimaryEmail({
        appUserId: this.modal.context['data']['appUserId'],
        body: this.userForm.value,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Primary email changed successfully';
          setTimeout(() => {
            this.modal.approve(this.userForm.value);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error.errorMessage ?? error.error.userMessage ?? error.error : error;
          this.error = this.error == "Password dont match" ? "Incorrect Password!" : this.error;
        }
      );
  }
  saveUsername() {
    this.accountSvc
      .changeUserName({
        appUserId: this.modal.context['data']['appUserId'],
        body: this.userForm.value,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Username changed successfully';
          setTimeout(() => {
            this.modal.approve(this.userForm.value);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error.errorMessage ?? error.error.userMessage ?? error.error : error;
          this.error = this.error == "Password dont match" ? "Incorrect Password!" : this.error;
        }
      );
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class UsernameChangeModal extends ComponentModalConfig<
  IUsernameChangeModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isUsername: boolean,
    size: ModalSize = ModalSize.Small
  ) {
    super(UsernameChangeModalComponent, { title, data, isUsername });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
